import React from 'react';
import Dropdown from "@/components/ui/Dropdown";

const Pagination = ({ currentPage, totalPages, onPageChange, per_page = 0, pages_text = "", className = "", onPerPageChange = null, perPageOptions = null }) => {
  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const defaultPerPageOptions = perPageOptions || [
    { label: '50 ', value: 50 },
    { label: '100 ', value: 100 },
    { label: '150 ', value: 150 },
    { label: '200 ', value: 200 }
  ];

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handlePerPageChange = (selectedOption) => {
    onPerPageChange(selectedOption);
  };

  const totalItems = totalPages * per_page;
  const startItem = ((currentPage - 1) * per_page) + 1;
  const endItem = Math.min(currentPage * per_page, totalItems);

  return (
    <div className={`flex justify-between items-center   space-x-2 mt-6 mb-2 ${className}`}>
      <div className='flex items-center space-x-2'>
        {(totalPages > 0 ) && (
          <div className="flex items-center text-sm text-muted-foreground">
            Page {currentPage} of {totalPages} {pages_text}
          </div>
        )}
        {(per_page > 1 && 0==1) && (
          <div className="flex items-center text-sm text-muted-foreground">
            {/* Showing {((currentPage - 1) * per_page) + 1} to {Math.min(currentPage * per_page, totalPages * per_page)} of total {totalPages * per_page} */}
            Showing item from {startItem} to {endItem} of total {totalItems}
          </div>
        )}
        {onPerPageChange && (
          <div className="flex items-center text-sm text-muted-foreground">
            &nbsp;|&nbsp; Per page:
            <Dropdown
              options={defaultPerPageOptions}
              value={defaultPerPageOptions.find(option => option.value === per_page)}
              onChange={handlePerPageChange}
              triggerClassName="h-[40px]"
              sortBy="numeric"
            />
          </div>
        )}
      </div>
      <div className='flex items-center space-x-2'>
        <button
          onClick={handlePrevious}
          disabled={currentPage === 1}
          className={`px-4 py-2 border rounded-md text-sm font-medium
            ${currentPage === 1
              ? 'bg-muted text-muted-foreground cursor-not-allowed'
              : 'bg-card text-foreground hover:bg-muted'}`}
        >
          Previous
        </button>
        <button
          onClick={handleNext}
          disabled={totalPages == 0 || currentPage === totalPages}
          className={`px-4 py-2 border rounded-md text-sm font-medium
            ${totalPages == 0 || currentPage === totalPages
              ? 'bg-muted text-muted-foreground cursor-not-allowed'
              : 'bg-card text-foreground hover:bg-muted'}`}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination; 